"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Enumerable.MapSet", "count", 1, "public", [{params: (context) => [Type.variablePattern("map_set_0")], guards: [], body: (context) => {
return Type.tuple([Type.atom("ok"), Elixir_MapSet["size/1"](context.vars.map_set_0)]);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));